(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boost-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boost-truck-gallery"] && !Shopify.designMode) return;
  try {
    
  class BoostTruckGallery extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-gallery-stage]');
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.status = this.querySelector('[data-gallery-status]');
      this.toggle = this.querySelector('[data-gallery-toggle]');
      this.lightbox = this.querySelector('[data-gallery-lightbox]');
      this.index = 0;
      this.timer = null;
      this.userPaused = false;
      this.hovering = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.track || this.slides.length === 0) return;

      this.setupClones();
      this.bindEvents();
      this.measure();
      this.apply(false);
      this.updateThumbs();
      this.setupLightbox();
      this.play();
    }

    disconnectedCallback() {
      this.stop();
      window.clearTimeout(this.snapTimer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    get visible() {
      const value = parseInt(getComputedStyle(this).getPropertyValue('--bc-visible'), 10);
      return Number.isFinite(value) && value > 0 ? value : 3;
    }

    get count() {
      return this.slides.length;
    }

    get autoplayEnabled() {
      return this.hasAttribute('data-autoplay') && this.count > this.visible && !this.reducedMotion.matches;
    }

    setupClones() {
      this.clones = this.slides.slice(0, 3).map((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-slide');
        clone.querySelectorAll('button').forEach((button) => button.setAttribute('tabindex', '-1'));
        this.track.appendChild(clone);
        return clone;
      });
    }

    bindEvents() {
      this.addEventListener('click', this.handleClick.bind(this));
      this.track.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
      this.stage.addEventListener('pointerenter', () => this.setHover(true));
      this.stage.addEventListener('pointerleave', () => this.setHover(false));
      this.stage.addEventListener('focusin', () => this.setHover(true));
      this.stage.addEventListener('focusout', () => this.setHover(false));
      document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.play()));
      this.reducedMotion.addEventListener('change', () => this.play());

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.measure();
          this.apply(false);
        });
        this.resizeObserver.observe(this.stage);
      }
    }

    handleClick(event) {
      const target = event.target;
      if (target.closest('[data-gallery-prev]')) return this.step(-1, true);
      if (target.closest('[data-gallery-next]')) return this.step(1, true);
      if (target.closest('[data-gallery-toggle]')) return this.toggleAutoplay();

      const thumb = target.closest('[data-gallery-thumb]');
      if (thumb) return this.goTo(Number(thumb.dataset.index), true, true);

      const trigger = target.closest('[data-gallery-trigger]');
      if (trigger) return this.openLightbox(Number(trigger.dataset.index), trigger);

      if (target.closest('[data-lightbox-close]')) return this.lightbox.close();
      if (target.closest('[data-lightbox-prev]')) return this.showLightbox(this.lightboxIndex - 1);
      if (target.closest('[data-lightbox-next]')) return this.showLightbox(this.lightboxIndex + 1);
      if (target === this.lightbox) this.lightbox.close();
    }

    measure() {
      const first = this.slides[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.stepSize = first.getBoundingClientRect().width + gap;
    }

    apply(animate) {
      this.track.classList.toggle('is-snapping', !animate);
      this.track.style.setProperty('--bc-offset', String(this.index * this.stepSize));
      if (!animate) void this.track.offsetWidth;
    }

    step(direction, fromUser) {
      this.goTo(this.index + direction, true, fromUser);
    }

    goTo(index, animate, fromUser) {
      if (fromUser) this.restart();
      if (index < 0) {
        this.index = this.count;
        this.apply(false);
        index = this.count - 1;
      }
      this.index = Math.min(index, this.count);
      this.apply(animate);
      this.updateThumbs();
      if (this.index === this.count) this.scheduleSnap();
    }

    scheduleSnap() {
      window.clearTimeout(this.snapTimer);
      this.snapTimer = window.setTimeout(() => this.snapToStart(), 700);
    }

    handleTransitionEnd(event) {
      if (event.target === this.track) this.snapToStart();
    }

    snapToStart() {
      window.clearTimeout(this.snapTimer);
      if (this.index < this.count) return;
      this.index = 0;
      this.apply(false);
      this.updateThumbs();
    }

    updateThumbs() {
      const first = this.index % this.count;
      const active = new Set();
      for (let offset = 0; offset < this.visible; offset += 1) active.add((first + offset) % this.count);
      this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', active.has(i) ? 'true' : 'false'));
      if (this.status) this.status.textContent = `Showing photos ${first + 1} to ${((first + this.visible - 1) % this.count) + 1} of ${this.count}`;
    }

    setHover(value) {
      this.hovering = value;
      this.play();
    }

    shouldPlay() {
      const lightboxOpen = Boolean(this.lightbox && this.lightbox.open);
      return this.autoplayEnabled && !this.userPaused && !this.hovering && !document.hidden && !lightboxOpen;
    }

    play() {
      if (!this.shouldPlay()) return this.stop();
      if (this.timer) return;
      const interval = Math.max(2000, Number(this.dataset.interval) || 3000);
      this.timer = window.setInterval(() => this.step(1, false), interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.play();
    }

    toggleAutoplay() {
      this.userPaused = !this.userPaused;
      this.toggle.setAttribute('aria-pressed', String(this.userPaused));
      this.toggle.setAttribute('aria-label', this.userPaused ? 'Resume automatic rotation' : 'Pause automatic rotation');
      this.toggle.querySelector('.bc-gallery__control-icon--pause').hidden = this.userPaused;
      this.toggle.querySelector('.bc-gallery__control-icon--play').hidden = !this.userPaused;
      this.play();
    }

    setupLightbox() {
      if (!this.lightbox || typeof this.lightbox.showModal !== 'function') {
        this.lightbox = null;
        return;
      }
      this.lightboxImage = this.lightbox.querySelector('[data-lightbox-image]');
      this.lightboxCounter = this.lightbox.querySelector('[data-lightbox-counter]');
      this.triggers = this.slides.map((slide) => slide.querySelector('[data-gallery-trigger]'));
      this.lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.showLightbox(this.lightboxIndex - 1);
        if (event.key === 'ArrowRight') this.showLightbox(this.lightboxIndex + 1);
      });
      this.lightbox.addEventListener('close', () => {
        document.documentElement.style.removeProperty('overflow');
        if (this.returnFocusTo) this.returnFocusTo.focus();
        this.play();
      });
    }

    openLightbox(index, trigger) {
      if (!this.lightbox) return;
      this.returnFocusTo = trigger;
      this.showLightbox(index);
      document.documentElement.style.setProperty('overflow', 'hidden');
      this.lightbox.showModal();
      this.stop();
    }

    showLightbox(index) {
      const total = this.triggers.length;
      this.lightboxIndex = ((index % total) + total) % total;
      const trigger = this.triggers[this.lightboxIndex];
      this.lightboxImage.src = trigger.dataset.fullSrc;
      this.lightboxImage.alt = trigger.dataset.alt || '';
      if (this.lightboxCounter) this.lightboxCounter.textContent = `${this.lightboxIndex + 1} / ${total}`;
    }
  }

  if (!customElements.get('boost-truck-gallery')) {
    customElements.define('boost-truck-gallery', BoostTruckGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
